export default "__VITE_ASSET__tPlVq0um__"